import React from "react"
import {Avatar, Box, Grid, Stack, TextField, Typography} from "@mui/material";
import Icon from "@mdi/react";
import {AssignableUsers, Template, Workflow, WorkflowUtils} from "../../../models";
import {Autocomplete} from "@mui/lab";
import {t} from "@lingui/macro";

interface OptionsType {
    id: string,
    name: string
}

interface AssignComponentProps {
    data: Workflow | Template
    users: AssignableUsers[]
    selectionCallback: (id: string) => void
}

interface AssignComponentState {
    personSelected: string
    timeout: any
    userValue: any
    userInputValue: string
    userOptions: OptionsType[]
}

export default class AssignComponent extends React.Component<AssignComponentProps, AssignComponentState>
{
    static defaultProps = {
        template: false,
    };

    constructor(props: AssignComponentProps) {
        super(props);
        this.state = {
            personSelected: "",
            userValue: null,
            userInputValue: "",
            userOptions: [],
            timeout: null
        }
    }

    componentDidMount() {
        this.initialize()
    }

    private initialize = () => {
        this.setUserOptions(this.props.users, true)
    }

    private fetchUsers = (input: string) => {
        if(this.state.timeout){
            clearTimeout(this.state.timeout)
        }
        this.setState(() => ({
            timeout: setTimeout(() => this.filterUsers(input), 1000)
        }))
    }

    private filterUsers = (input: string) => {
        let newList: AssignableUsers[] = []

        this.props.users.map((user) => {
            let userName = (user.accountDetails.firstName ?? "") + (user.accountDetails.lastName ? " " + user.accountDetails.lastName : "") + " - " + user.username
            if (userName.includes(input)){
                newList.push(user)
            }
        })

        this.setUserOptions(newList)
    }

    private setUserOptions = (newList: AssignableUsers[], init?: boolean) => {
        let userOptions: OptionsType[] = []

        newList.map((user) => userOptions.push(
            {
                id: user.id,
                name: (user.accountDetails.firstName ?? "") + (user.accountDetails.lastName ? " " + user.accountDetails.lastName +  " - " : "") + user.username
            }
        ))

        if(init){
            this.setState(() => ({
                userOptions: userOptions
            }), this.setAssignValue)
        }
        else {
            this.setState(() => ({
                userOptions: userOptions
            }))
        }
    }

    private setAssignValue = () => {
        if (this.state.userOptions.length > 0) {
            if((this.props.data as Workflow).executor !== undefined && (this.props.data as Workflow).executor !== null){
                let userValue = this.state.userOptions.find((user) => {
                    if(user.id === (this.props.data as Workflow).executor.id){
                        return user
                    }
                })

                this.setState(() => ({
                    userValue: userValue !== undefined? userValue : null,
                    userOptions: []
                }))
            }
            if((this.props.data as Template).defaultExecutor !== undefined && (this.props.data as Template).defaultExecutor !== null){
                let userValue = this.state.userOptions.find((user) => {
                    if(user.id === (this.props.data as Template).defaultExecutor.id){
                        return user
                    }
                })
                this.setState(() => ({
                    userValue: userValue !== undefined? userValue : null,
                    userOptions: []
                }))
            }
        }
    }

    render() {
        let {userValue, userOptions} = this.state

        return (
            <Grid container sx={{mt: 2}} alignItems={"center"}>
                <Grid item xs={1}>
                    <Avatar sx={{
                        backgroundColor: "primary.main",
                        width: 64,
                        height: 64,
                    }}>
                        <Box
                            component={Icon}
                            path={WorkflowUtils.renderIcon(this.props.data.objectType)}
                            size="40px"
                            sx={{
                                color: "primary.contrastText",
                                backgroundColor: "primary.main",
                                padding: "4px"
                            }}>
                        </Box>
                    </Avatar>
                </Grid>
                <Grid item xs={11}>
                    <Stack direction="column">
                        <Typography color="primary.main" sx={{ fontSize: 22, fontWeight: '500', lineHeight: 1 }}>
                            {this.props.data.name}
                        </Typography>
                        <Typography color="gray" sx={{ fontSize: 12 }}>
                            {this.props.data.description}
                        </Typography>
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <Autocomplete
                        getOptionLabel={(option) => option.name}
                        filterOptions={(x) => x}
                        options={userOptions}
                        autoComplete
                        includeInputInList
                        filterSelectedOptions
                        value={userValue}
                        sx={{mt: 3}}
                        noOptionsText={t({id: "create-contract-modal.no-user", message: "Inizia a digitare per avviare la ricerca"})}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                this.setState(() => ({
                                    userValue: newValue,
                                    userOptions: [newValue, ...userOptions],
                                    personSelected: newValue.id
                                }), () => this.props.selectionCallback(this.state.personSelected));
                            }
                        }}
                        onInputChange={(event, newInputValue) => {
                            this.setState({ userInputValue: newInputValue }, () => {
                                if (this.state.userInputValue === '') {
                                    this.setState({ userOptions: userValue ? [userValue] : [] });
                                }
                                else {
                                    this.fetchUsers(this.state.userInputValue)
                                }
                            })
                        }}
                        renderInput={(params) => (
                            <TextField {...params}
                                       label={t({id: "create-contract-modal.select-user", message: "Assegna a..."})}
                                       fullWidth
                                       required
                            />
                        )}
                    />
                </Grid>
            </Grid>
        )
    }
}
